<template>
  <div class="crp" :class="{ 'crp--disabled': disabled }">
    <i class="far fa-calendar-alt crp__icon" />
    <date-picker
      :append-to-body="false"
      class="w-100"
      :clearable="false"
      :disabled="disabled"
      :editable="false"
      :format="format"
      :lang="lang"
      :placeholder="placeholder"
      range
      :show-time-panel="false"
      :value="value"
      value-type="date"
      @input="onInput"
    />
    <button
      v-if="clearable && hasValue && !disabled"
      class="crp__clear"
      type="button"
      @click="clear"
    >
      ×
    </button>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

export default {
  /** Selector de rango de fechas (solo calendario, no editable por teclado). */
  name: 'CustomDateRangePicker',
  components: { DatePicker },
  props: {
    /** Rango seleccionado como arreglo [inicio, fin] de objetos Date. */
    value: {
      type: Array,
      default: () => [null, null],
    },
    placeholder: {
      type: String,
      default: 'Seleccionar Rango',
    },
    format: {
      type: String,
      default: 'DD/MM/YYYY',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      lang: 'es',
    };
  },
  computed: {
    hasValue() {
      return !!(this.value && (this.value[0] || this.value[1]));
    },
  },
  methods: {
    onInput(value) {
      this.$emit('input', value);
    },
    clear() {
      this.$emit('input', [null, null]);
    },
  },
};
</script>

<style scoped lang="scss">
$field-height: 38px;
$app-orange: #ff7058;
$app-orange-light: #ffe1db;

.crp {
  position: relative;
  width: 100%;
}
.crp__icon {
  position: absolute;
  top: 50%;
  left: 12px;
  transform: translateY(-50%);
  color: $app-orange;
  z-index: 2;
  pointer-events: none;
}

/* White input, left calendar icon, matched height */
.crp ::v-deep .mx-input {
  height: $field-height;
  padding-left: 34px;
  border: 1px solid #c5cdcf;
  box-shadow: none;
  background-color: #fff;
  color: #495057;
}
.crp ::v-deep .mx-input::placeholder {
  color: #495057;
  opacity: 0.7;
}
.crp ::v-deep .mx-icon-calendar {
  display: none;
}

/* Custom clear (X): always visible while a range is selected */
.crp__clear {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  z-index: 3;
  padding: 0 4px;
  border: none;
  background: transparent;
  line-height: 1;
  font-size: 22px;
  font-weight: 400;
  color: #7f8c8d;
  cursor: pointer;
}
.crp__clear:hover {
  color: #495057;
}
.crp__clear:focus {
  outline: none;
}

/* Calendar theming: orange endpoints, lighter in-between, regular text color */
.crp ::v-deep .mx-calendar-content .cell {
  color: #000;
}
.crp ::v-deep .mx-btn-current-month,
.crp ::v-deep .mx-btn-current-year,
.crp ::v-deep .mx-calendar-header-label,
.crp ::v-deep .mx-table-date th {
  color: #000;
}
.crp ::v-deep .mx-calendar-content .cell.active {
  background-color: $app-orange;
  color: #fff;
  border-radius: 4px;
}
.crp ::v-deep .mx-calendar-content .cell.in-range,
.crp ::v-deep .mx-calendar-content .cell.hover-in-range {
  background-color: $app-orange-light;
  color: #000;
}
.crp ::v-deep .mx-calendar-content .cell.today {
  color: $app-orange;
}
.crp ::v-deep .mx-calendar-content .cell.active.today {
  color: #fff;
}
.crp ::v-deep .mx-calendar-content .cell:hover {
  background-color: $app-orange-light;
  color: #000;
}
/* Hide adjacent-month days (must win over in-range / hover) */
.crp ::v-deep .mx-calendar-content .cell.not-current-month {
  color: transparent !important;
  background-color: transparent !important;
  pointer-events: none;
}
</style>
